import React, { useState } from 'react';
import { Hexagon } from 'lucide-react';

// Roobet VIP level icon from the leaderboard API; unranked/broken icons fall back to a neutral hexagon.
export const RankBadge = ({ src, size = 28, testId }) => {
  const [ok, setOk] = useState(true);
  if (!src || !ok || /image0\.png$/.test(src)) {
    return <Hexagon size={size * 0.8} className="flex-shrink-0 text-slate-500" style={{ width: size, height: size }} aria-label="Unranked" role="img" data-testid={testId} />;
  }
  return <img src={src} alt="Roobet VIP level" title="Roobet VIP level" width={size} height={size} onError={() => setOk(false)} data-testid={testId} className="object-contain flex-shrink-0" style={{ width: size, height: size }} />;
};
